import styled, { css } from "styled-components";
import { margins, sizes } from "../core/enhancers";
var Logo = styled.svg.withConfig({
  displayName: "Logowrapper__Logo",
  componentId: "sc-x306f9-0"
})(["", " ", " ", ""], margins, sizes, function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return css(["color:", ";"], theme.componentsTokens.logo.variants[variant || theme.componentsTokens.logo.defaultVariant].color);
});
export default Logo;